import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Line from '../Line'
import AssesmentForsiLine from '../AssesmentForsiLine'
import Estimation from '../Estimation'
import ManualBody from '../ManualBody'
import AssessmentRPReportFiles from '../AssessmentRPReportFiles'
import AssessmentReportSums from '../AssessmentReportSums'

// Constants
import { FILE_STORAGE_API } from '../../../../constants'

// Utils
import { renderFullDate } from '../../../../utils/time'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'
import { setCarActiveState } from '../../../../actions/car'

import './assessmentforsi.scss'
import RPReportFiles from '../RPReportFiles'
import Button from '../../../elements/button'
import Icon from '../../../elements/icon'
import { FileIcons } from '../../../elements/icons'

const LineType = {
  Generic: 0,
  Work: 1,
  AdditionalWork: 2,
  Material: 3,
  StartTime: 4,
  Addition: 5,
  Deduction: 6,
  Environment: 7
}
const REPORTYPE = {
  Unknown: 0,
  Forsi: 1,
  ForsiManual: 2,
  DBS: 3
}

const DEPARTMENTTYPE = {
  Paint: 0,
  Body: 1
}
class AssessmentForsi extends Component {
  constructor (props) {
    super(props)
    this.state = {
      order: null,
      department: {},
      isPaint: false,
      isBody: false,
      attachment: null
    }
  }

  componentDidMount () {
    if (this.props.onRef) this.props.onRef(this)
    this.getDepartment()

    const isEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3'
    const isAfterEvaluation = this.props.orderPrice !== undefined && this.props.orderPrice.IsAfterEvaluation
    let hasReport = this.props.order && this.props.order.Report && this.props.order.Report.ReportType === 2
    if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
      this.props.setCarActiveState(false)
    }
  }

  componentWillUnmount () {
    if (this.props.onRef) this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    if (typeof next.order !== 'object') return
    this.setState({
      order: next.order
    })
    this.getDepartment()
  }

  getTitleAria () {
    // if (this.props.orderPrice === null) return null
    if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  getEditUrl () {
    if (!this.props.order.Report.IsApproved) {
      if (this.props.department === DEPARTMENTTYPE.Paint && this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
        if (this.props.order !== null && this.props.order.IsAssessmentOk === true) return null

        return '/pricecalculation/' + this.props.order.Id + '/1'
      }
      if (this.props.department === DEPARTMENTTYPE.Body) {
        return '/pricecalculation/' + this.props.order.Id + '/manualbody'
      }
    }
    return null
  }

  getTitle () {
    let reportType = this.props.order.Report.ReportType
    if (reportType === REPORTYPE.Forsi) return translation(70)
    if (reportType === REPORTYPE.ForsiManual) {
      if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
        return translation(1396)
      }
      switch (this.props.order.OrderType) {
        case 1:
          return translation(13360)
        case 2:
          return translation(71)
        case 3:
          return translation(13361)
        case 4:
          return translation(73)
        case 6:
          return translation(785)
      }
      return 'No title'
    }
  }

  getIcon () {
    let reportType = this.props.order.Report.ReportType
    if (reportType === REPORTYPE.Forsi) return '/images/svgs/workscreen/Insurance-black.svg'
    if (reportType === REPORTYPE.ForsiManual) {
      // if (this.props.orderPrice === null) return null
      if (this.props.orderPrice !== null && this.props.orderPrice.IsAddonPrice) {
        return '/images/svgs/taksering/Additional-sales-new.svg'
      }
      switch (this.props.order.OrderType) {
        case 1:
          return '/images/svgs/ordrer/Insurance-black.svg'
        case 2:
          return '/images/svgs/ordrer/Salescar-black.svg'
        case 3:
          return '/images/svgs/ordrer/Garanteed-black.svg'
        case 4:
          return '/images/svgs/ordrer/Other-black.svg'
        case 6:
          return '/images/svgs/ordrer/Private_c-black.svg'
      }
      return null
    }
  }

  getDepartment () {
    if (typeof this.props.order.Report !== 'object' || this.props.order.Report === null) return null

    let department = this.props.order.Report
    let attachment = this.props.order.Report.Attachments.find(item => this.formatSectionType(item.SectionType) === this.props.department)
    if (this.props.department === DEPARTMENTTYPE.Paint) {
      let lines = [ ...department.Paint.Lines ]
      this.setState({
        department: {
          ...department.Paint,
          Lines: lines
        },
        isPaint: true,
        attachment
      })
    }
    if (this.props.department === DEPARTMENTTYPE.Body) {
      let lines = [ ...department.Body.Lines ]
      this.setState({
        department: {
          ...department.Body,
          Lines: lines
        },
        isBody: true,
        attachment
      })
    }
  }

  renderDownloadlink () {
    const attachment = this.state.attachment

    if (attachment && attachment.OrderFileId !== null) {
      if (attachment.FileName === null) return null
      const {Report} = this.props.order
      let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      let translateKey
      if (this.props.auth.departmentType === DEPARTMENTTYPE.Body) {
         // Additional report = V-Nr > 0
        if (Report && Report.IsApproved && Report.ReportVersionNr > 0) {
          translateKey = this.state.isBody ? '937' : '14836'
        } else {
          // head report
          translateKey = this.state.isBody ? '936' : '14836'
        }
      }

      if (this.props.auth.departmentType === DEPARTMENTTYPE.Paint) {
        if (Report && Report.IsApproved && Report.ReportVersionNr > 0) {
          translateKey = '937'
        } else {
          // head report
          translateKey = '936'
        }
      }

      const renderText = () => {
        // <img src='/images/svgs/download.svg' alt='' className='downloadIcon' />
        return (
          <div className='text downloadLink'>
            {translation(translateKey)}
            <a href={newFileUrl} title={attachment.FileName} target='_blank'><Icon icon={FileIcons.Download_Black} size='xs' /></a>
          </div>
        )
      }

      return (
        <div className='forsiPDF'>
          <Line text={renderText} amount={renderFullDate(this.props.order.Report.CreatedDate)} noFormat />
        </div>
      )
    }
  }

  renderPrices () {
    let isPaint = this.state.isPaint
    let isBody = this.state.isBody

    let showPrices = hasAccess([6], this.props.auth.user.UserType) || this.props.showPrices || this.props.order.ShowPrices
    if (!showPrices) return null

    if (this.props.showOnlyWork) return null
    let section = this.state.department
    let renderHourPrice = (isPaint && hasSubscriptionPermission(this.props.auth, 10)) || isBody
    return (
      <div>
        {renderHourPrice && <div><Line boldText text={translation('419') + ':'} amount={section.HourPrice} currencyType={translation(this.props.currencyCode)} /></div>}
        <AssessmentReportSums report={this.props.order.Report} department={this.props.department} currencyCode={this.props.currencyCode} />
      </div>
    )
  }

  formatSectionType (sectionType) {
    switch (sectionType) {
      case 1:
        return DEPARTMENTTYPE.Paint
      case 2:
        return DEPARTMENTTYPE.Body
      default:
        break
    }
  }

  renderForsiCompany () {
    if (!this.props.order.Report.InsuranceCompany) return null

    return (
      <div>
        <Line boldText text={translation('418') + ':'} amount={this.props.order.Report.InsuranceCompany} noFormat />
      </div>
    )
  }

  renderClasses (from) {
    let department = this.state.department
    let reportType = this.props.order.Report.ReportType
    let className = ''
    switch (reportType) {
      case REPORTYPE.Forsi:
        if (from === 'render') {
          className = department === DEPARTMENTTYPE.Body ? 'forsi-body' : 'forsi'
          return className
        }
        className = department === DEPARTMENTTYPE.Body ? 'forsi-body' : ''
        return className

      case REPORTYPE.ForsiManual:
        className = 'assessment-forsi'
        if (from === 'renderWarning') {
          className += '__red'
          return className
        }
        return className

      default:
        break
    }
  }

  renderAE (department) {
    if (!(this.props.order.ShowAE || this.props.showAE)) return null
    let className = this.renderClasses() + '__sum'
    return (
      <div>
        <Line isTotal amount={department.TotalWorkUnits} noFormat currencyType={translation('885')} className={className} />
      </div>
    )
  }

  renderWarning (hasDifference) {
    if (!hasDifference) return null
    let className = 'forsi_diff assessment-forsi__red '
    return <div className={className}>{translation('749')}</div>
  }

  renderLines (lines, lineType, boldText, boldAmount) {
    let showAE = this.props.order.ShowAE
    let showPrices = this.props.order.ShowPrices
    return (
      <div>
        {lines.filter(line => line.LineType === lineType).map((line, key) => {
          return (
            <div key={key}>
              <AssesmentForsiLine line={line} boldText={boldText} boldAmount={boldAmount} reportType={this.props.order.Report.ReportType} key={key} currencyCode={this.props.currencyCode} showPrices={showPrices} showAE={showAE} />
            </div>
          )
        })}
      </div>
    )
  }

  // Forsi manual / RP report (same thing)
  renderForsiManual (reportSection) {
    // console.log('renderForsiManual')
    var attachment = this.state.attachment
    const renderHourPrice = () => {
      if (!this.props.order.ShowPrices) return null
      if (this.props.showOnlyWork) return null
      if (reportSection.HourPrice === 0) return null
      return <Line boldText text={translation('419')} amount={reportSection.HourPrice} noFormat currencyType={this.props.currencyCode} />
    }

    const renderIsApproved = (isApproved) => {
      let label = isApproved ? translation('16483') : translation('16482')
      return <div className='forsi_diff assessment-forsi__red'>{label}</div>
    }

    const renderReportSums = () => {
      if (!this.props.order.ShowPrices || this.props.showOnlyWork) return null

      let sumDepartment = this.props.department
      if (this.props.department === 1) {
        sumDepartment = 2   // If body department, render both body and paint
      }

      return (<AssessmentReportSums report={this.props.order.Report} department={sumDepartment} currencyCode={this.props.currencyCode} includeTotal={false} />)
    }

    // Paint
    if (this.props.department === DEPARTMENTTYPE.Paint) {
      return (
        <div className='manual-paint'>
          {!this.props.editable && renderIsApproved(this.props.order.Report.IsApproved)}
          {!this.props.editable && this.renderWarning(this.props.order.Report.CheckReportCalculation || reportSection.CheckReportCalculation)}
          {!this.props.editable && this.props.viewMode !== 'hover' && <AssessmentRPReportFiles attachment={attachment} order={this.props.order} showDates />}

          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Work)}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.AdditionalWork)}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.StartTime, true)}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderAE(reportSection)}
          {!this.props.editable && <br key='br1' />}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Generic, true, false)}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && renderHourPrice()}
          {renderReportSums()}
          {this.props.editable && this.renderRpReports()}
          {this.props.editable && <Button onClick={this.props.goBack} labelText={translation('956')} />}
        </div>
      )
    }
    // Body
    if (this.props.department === DEPARTMENTTYPE.Body) {
      return (
        <div className='manual-body'>
          {!this.props.editable && renderIsApproved(this.props.order.Report.IsApproved)}
          {!this.props.editable && this.renderWarning(this.props.order.Report.CheckReportCalculation || reportSection.CheckReportCalculation)}
          {!this.props.editable && this.props.viewMode !== 'hover' && <AssessmentRPReportFiles attachment={attachment} order={this.props.order} showDates />}

          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Work)}
          {!this.props.editable && reportSection.Lines.findIndex(x => x.LineType === LineType.AdditionalWork) !== -1 && <hr />}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.AdditionalWork)}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderAE(reportSection)}

          {!this.props.editable && reportSection.Lines.findIndex(x => x.LineType === LineType.Generic) !== -1 && <br />}
          {!this.props.editable && (hasSubscriptionPermission(this.props.auth, 20) || hasPartnerSubscriptionPermission(this.props.auth, 20)) && this.renderLines(reportSection.Lines, LineType.Generic)}
          {!this.props.editable && reportSection.Lines.findIndex(x => x.LineType === LineType.Generic) !== -1 && <br />}

          {!this.props.editable && hasSubscriptionPermission(this.props.auth, 20) && renderHourPrice()}
          {!this.props.showOnlyWork && (<ManualBody {...this.props} hideTitle hideFile noRef />)}
        </div>
      )
    }

    return null
  }

  renderForsi (section) {
    let ispaint = this.state.isPaint
    let isBody = this.state.isBody
    let isPaintPermission = (hasSubscriptionPermission(this.props.auth, 10) || hasPartnerSubscriptionPermission(this.props.auth, 10)) && ispaint

    const renderIsApproved = () => {
      if (this.props.order.Report.ReportType === 1) return null  // Don't render approved notice when report was not manually uploaded
      return <div className='forsi_diff assessment-forsi__red'>{this.props.order.Report.IsApproved ? translation('16483') : translation('16482')}</div>
    }

     // Body and paint
    const renderWithSelectedEvaluation = () => {
      return (
        <div>
          {renderIsApproved()}
          {this.renderWarning(this.props.order.Report.CheckReportCalculation || section.CheckReportCalculation)}
          {this.renderDownloadlink()}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.Work)}
          {isBody && (section.Lines.findIndex(x => x.LineType === LineType.AdditionalWork) !== -1) && <hr />}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.AdditionalWork)}
          {isPaintPermission && this.renderLines(section.Lines, LineType.StartTime, true)}
          {(isBody || isPaintPermission) && this.renderAE(section)}
          {<br />}
          {isPaintPermission && this.renderLines(section.Lines, LineType.Generic, true, false)}
          {this.renderPrices()}
          {(isBody || isPaintPermission) && this.renderForsiCompany()}
          {<br />}
          {isBody && this.renderLines(section.Lines, LineType.Generic)}
          <div className='clearfix spacing20' />
          <Estimation {...this.props} renderAdditional overrideInnerTitle={translation(891)} />
        </div>
      )
    }

    // Body and paint
    const renderSimple = () => {
      return (
        <div>
          {renderIsApproved()}
          {this.renderWarning(this.props.order.Report.CheckReportCalculation || section.CheckReportCalculation)}
          {this.renderDownloadlink()}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.Work)}
          {this.props.department === 1 && (section.Lines.findIndex(x => x.LineType === LineType.AdditionalWork) !== -1) && <hr />}
          {(isBody || isPaintPermission) && this.renderLines(section.Lines, LineType.AdditionalWork)}
          {isPaintPermission && this.renderLines(section.Lines, LineType.StartTime, true)}
          {(isBody || isPaintPermission) && this.renderAE(section)}
          {<br />}
          {isPaintPermission && this.renderLines(section.Lines, LineType.Generic, true, false)}
          {this.renderPrices()}
          {(isBody || isPaintPermission) && this.renderForsiCompany()}
          {<br />}
          {isBody && this.renderLines(section.Lines, LineType.Generic)}
        </div>
      )
    }

    let content = null
    if (this.props.useSelectedEvaluation && this.props.orderPrice !== null && this.props.orderPrice.AdditionalParts !== null && this.props.orderPrice.AdditionalParts.length > 0 && [4, 5, 6, 7].includes(this.props.order.SelectedEvaluationType)) {
      content = renderWithSelectedEvaluation()
    } else {
      content = renderSimple()
    }
    return (
      <div className={this.renderClasses('render')}>
        {content}
      </div>
    )
  }

  renderRpReports () {
    if (!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10)) return null
    let renderPaint = this.props.editable || this.props.department === 0
    let renderBody = this.props.editable || this.props.department === 1
    let renderSparePart = this.props.editable
    return <RPReportFiles
      order={this.props.order}
      editable={this.props.editable}
      renderPaint={renderPaint}
      renderBody={renderBody}
      renderSparePart={renderSparePart}
      onUploadSuccess={this.props.loadOrder.bind(this, true)}
      showDates={!this.props.editable}
      />
  }

  render () {
    let section = this.state.department

    if (!this.props.order.Report) return null
    if (Object.keys(section).length < 1) return null

    let reportType = this.props.order.Report.ReportType
    if (reportType === REPORTYPE.Forsi) {
      return this.renderForsi(section)
    }
    if (reportType === REPORTYPE.ForsiManual) {
      return this.props.editable ? this.renderForsiManual(section) : this.renderForsi(section)
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}
export default connect(mapStateToProps, {
  setCarActiveState
})(AssessmentForsi)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/AssessmentForsi/index.js